

    var $ = require('@alife/alpha-jquery/jquery'),
        Position = require('@alife/alpha-position/position'),
        Widget = require('@alife/alpha-widget/widget'),
        log = require('@alife/alpha-util/log'),
        Manager = require('./manager');

    var isPad = navigator.userAgent.match(/iPad/i);
    var padShim;

    // Overlay
    // -------
    // Overlay 组件的核心特点是可定位（Positionable）和可层叠（Stackable）
    // 是一切悬浮类 UI 组件的基类

    var Overlay = Widget.extend({

        attrs: {
            // 基本属性
            width: null,
            height: null,
            visible: false,
            autoFocus: true,
            zIndex: 99,
            // 定位配置
            align: {
                // element 的定位点，默认为左上角
                selfXY: [0, 0],
                // 基准定位元素，默认为当前可视区域
                baseElement: Position.VIEWPORT,
                // 基准定位元素的定位点，默认为左上角
                baseXY: [0, 0]
            },

            // 父元素
            parentNode: document.body
        },

        closingReason: {},

        show: function() {
            // 若从未渲染，则调用 render
            if (!this.rendered) {
                this.render();
            }
            this.set('visible', true);
            return this;
        },

        hide: function() {
            this.closingReason = {cancel: false};
            this.set('visible', false);
            return this;
        },

        cancel: function(){
            this.closingReason = {cancel: true};
            this.set('visible', false);
            return this;
        },

        setup: function() {
            // 窗口resize时，重新定位浮层
            this.focusNode = this.element.find('[autofocus]');
            if(!this.focusNode.length){
                this.focusNode = this.element;
            }
            Manager.addOverlay(this);
            // 针对 ipad 的处理
            this._setupIPad();

            this.after('render', function() {
                var pos = this.element.css('position');
                if (this.get('align') && (pos === 'static' || pos === 'relative')) {
                    this.element.css({
                        position: 'absolute',
                        left: '-9999px',
                        top: '-9999px'
                    });
                }
            });
            // 统一在显示之后重新设定位置
            this.after('show', function(){
                this.setPosition();
            });
        },

        destroy: function() {
            Manager.removeOverlay(this);
            return Overlay.superclass.destroy.call(this);
        },

        _setPosition: function(align){
            log.deprecated('_setPosition', 'setPosition', '1.1.0');
            this.setPosition(align);
        },

        // 进行定位
        setPosition: function(align) {
            // 不在文档流中，定位无效
            if (!$.contains(document.documentElement, this.element[0])) {
                return;
            }

            align || (align = this.get('align'));

            // 如果align为空，表示不需要使用js对齐
            if(!align) {
                return;
            }

            var isHidden = this.element.css('display') === 'none';

            // 在定位时，为避免元素高度不定，先显示出来
            if (isHidden) {
                this.element.css({
                    visibility: 'hidden',
                    display: 'block'
                });
            }

            Position.pin({
                element: this.element,
                x: align.selfXY[0],
                y: align.selfXY[1]
            }, {
                element: align.baseElement,
                x: align.baseXY[0],
                y: align.baseXY[1]
            });

            // 定位完成后，还原
            if (isHidden) {
                this.element.css({ visibility: '', display: 'none' });
            }

            return this;
        },



        // 针对 ipad 的处理
        _setupIPad: function(){
            if(isPad){
                if(!padShim){
                    padShim = $('<a href="javascript:void(0);" style="outline:none;display:block;position:absolute;left:0;top:0;zoom:1.01;opacity:1;background-color:transparent;"></a>');
                    padShim.hide().insertBefore($('body')[0].firstChild);

                    var targetElement;

                    // 为了保证 target 的准确性
                    padShim.on('click', function(e){
                        padShim.hide();
                        targetElement = document.elementFromPoint(e.clientX, e.clientY);
                        padShim.show();
                    });

                    // 利用冒泡的特性，模拟鼠标 click 事件
                    $(document).on('click', function(e){
                        if(e.target != padShim[0]){
                            return;
                        }

                        var $targetElement = $(targetElement);

                        switch(targetElement.tagName.toLowerCase()){
                            case 'select':
                                fakeMouseEvent(targetElement, e, 'mousedown');
                                break;
                            case 'textarea':
                                $targetElement.focus();
                                break;
                            case 'input':
                                var type = targetElement.type;
                                switch(type){
                                    case 'checkbox':
                                    case 'radio':
                                        fakeMouseEvent(targetElement, e, 'click');
                                        break;
                                    default:
                                        $targetElement.focus();
                                        break;
                                }
                                break;
                            default:
                                fakeMouseEvent(targetElement, e, 'click');
                                break;
                        }
                    });
                }

                this.before('destroy', function(){
                    padShim.hide();
                });

                // 用 visible 是最靠谱的，比 show/hide 还底层
                this.on('change:visible', function(val){
                    if(val){
                        var el = this.element;

                        //setTimeout(function(){
                        padShim.css('zIndex', el.parent()[0] == document.body ? el.css('zIndex') : 0)
                            .css('width', Math.max(document.documentElement.clientWidth, document.getElementsByTagName('body')[0].offsetWidth))
                            .css('height', Math.max(document.documentElement.clientHeight, document.getElementsByTagName('body')[0].offsetHeight))
                            .show();
                        //}, 300);
                    } else {
                        padShim.hide();
                    }
                });
            }
        },

        // 除了 element 和 relativeElements，点击 body 后都会隐藏 element
        _blurHide: function(arr) {
            arr = $.makeArray(arr);
            arr.push(this.element);
            this._relativeElements = arr;
            Manager.addOverlay(this, true);
        },

        // 用于 set 属性后的界面更新

        _onRenderWidth: function(val) {
            this.element.css('width', val);
        },

        _onRenderHeight: function(val) {
            this.element.css('height', val);
        },

        _onRenderZIndex: function(val) {
            this.element.css('zIndex', val);
        },

        _onRenderAlign: function(val) {
            this.setPosition(val);
        },

        _onRenderVisible: function(val) {
            if(val){
                this.element.show().removeAttr('aria-hidden');
                if(this.get('autoFocus')){
                    this.set('focused', true);
                }
                this.trigger('show');
            }else{
                this.element.hide().attr('aria-hidden', true);
                this.set('focused', false);
                this.trigger('hide', this.closingReason);
            }
        }

    });



    module.exports = Overlay;


    // Helpers
    // -------

    function fakeMouseEvent(targetElement, e, type){
        var clickEvent = document.createEvent('MouseEvents');
        clickEvent.initMouseEvent(type, true, true, window, 1, e.screenX, e.screenY, e.clientX, e.clientY, false, false, false, false, 0, null);
        clickEvent.forwardedTouchEvent = true;
        targetElement.dispatchEvent(clickEvent);
    }




